import { CommonModule } from '@angular/common';
import { Component, input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { AppCommonModule } from 'src/app/common.module';
import { IScheduleUser } from 'src/app/models/site.model';
import { SubItem } from 'src/app/models/sub-item.model';
import { User } from 'src/app/models/user.model';
import { TimesheetsService } from 'src/app/services/timesheets.service';

@Component({
  selector: 'app-sign-status',
  templateUrl: './sign-status.component.html',
  styleUrls: ['./sign-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    CommonModule,
    AppCommonModule,
  ],
})
export class SignStatusComponent implements OnInit {

  site = input<SubItem>();
  user = input.required<IScheduleUser | User>();
  date = input.required<Date>();
  showText = input(false);

  status$: Observable<string>;

  constructor(
    private timesheetService: TimesheetsService,
  ) { }

  ngOnInit(): void {
    this.status$ = this.timesheetService.getList({ user: this.user().guid, site: this.site()?.guid ?? null, date: this.date() }).pipe(
      map((timesheets) => timesheets?.length > 0 ? 'in' : 'out'),
      shareReplay({ bufferSize: 1, refCount: true }),
    );
  }
}
